import useStore from "../store";
import { useDynamicFont } from "./FontUtils";
import { convertStyle, convertWeight } from "./FormatUtils";

export interface FontUrl {
    font_style: string;
    font_weight: string | number;
    url: string;
    name: string;
}

export async function loadFonts(fontUrls: FontUrl[], baseUrl?: string): Promise<void> {
    if (!fontUrls?.length) return;
    const store = useStore();
    const environment = baseUrl ?? store.device_settings?.content_url ?? "";
    for (const f of fontUrls) {
        const { font_style, font_weight, url, name } = f;
        const fontUrl = `${environment}${url}`;
        console.log(`[Socket] Loading font ${name} with ${fontUrl}`);
        useDynamicFont({
            family: name,
            url: fontUrl,
            descriptors: {
                style: convertStyle(font_style),
                weight: convertWeight(font_weight),
            },
        });
    }
}

